import React, { Fragment } from 'react';
import { Dimmer, Loader as SemanticLoader, Segment } from 'semantic-ui-react';
import ErrorMessage from '../ErrorMessage';
import './FullScreenLoader.css';
import PlaceHolder from './PlaceHolder';

const withFullScreenLoading = Comp => ({
  isLoading,
  loadingMessage,
  error,
  children,
  ...props,
  noPlaceHolder,
}) => {
  const placeHolder = !noPlaceHolder;
  if (error) {
    return (
      <Dimmer inverted className="FullScreenLoader" active>
        <ErrorMessage error={error} />
      </Dimmer>
    );
  }
  if (isLoading) {
    return (
      <Dimmer.Dimmable className="FullScreenLoader" dimmed as={Segment}>
        {placeHolder && (
          <Fragment>
            <PlaceHolder />
            <PlaceHolder />
            <PlaceHolder />
          </Fragment>
        )}
        <Dimmer active inverted>
          <SemanticLoader size="large">
            <span className="FullScreenLoader__Text">
              {loadingMessage || 'Data laden'}
            </span>
          </SemanticLoader>
        </Dimmer>
      </Dimmer.Dimmable>
    );
  }
  return (
    <Comp {...props}>
      {children}
    </Comp>
  );
};

export default withFullScreenLoading;



// WEBPACK FOOTER //
// ./src/components/UtilityComponents/withFullScreenLoading/index.js